import React from 'react';
import {Button} from "./Button";

export const Card = (props) => {
  const {color, title, label, text, button, image, classes} = props;
  const bgImg = image ? {
    backgroundImage: `url(${image})`
  } : null ;

  function beakWords(text, className = 'bg-pink p2') {
    let words = text.split("|");
    if (words.length === 1)
      return `<span class="${className}">${text}</span>`
    words = words.filter(element => {
      return element !== '';
    });
    text = '';
    words.forEach(word => {
      text += `<span class="${className}">${word}</span>`
    })
    return text
  }


  return (
    <div
      className={`zg-card d-flex flex-column justify-content-between align-items-start p-4 border rounded-4 ${classes ? classes : ''}`}
      style={bgImg}
      >
      <div>
        <h3 className="h4 text-black mb-5 d-flex align-items-start">
          {title && (
            <span className={`d-flex flex-column align-items-start me-2`}
                  dangerouslySetInnerHTML={{__html: beakWords(title, `bg-${color} zg-line-height-sm letter-spacing-1 p-2 mb-1`)}}></span>
          )}
          {label && <span className={`d-inline-block bg-${color} px-2 py-1 zg-label`}>{label}</span>}
        </h3>
        {text && (
          <div className="zg-text-md" dangerouslySetInnerHTML={{__html: text}}></div>
        )}
      </div>
      {button && (
        <Button
          title={button.title}
          url={button.url}
          external={button.external || (button.target && button.target === "_blank")}
          classes="mt-5"
        />
      )}
    </div>
  )
}
